import { SenecEkpTheme } from "src/styles/ekp-theme/senecEkpTheme";
import { Typography, useTheme } from "@mui/material";
import { MonitoringCardHeader } from "src/components/cards/custom/monitoring-card/MonitoringCardHeader";
import { MonitoringCardProps, MonitoringCardTypeErrors } from "src/components/cards/custom/monitoring-card/MonitoringCard";

export const MonitoringErrorCard = ({ cardProps }: { cardProps: MonitoringCardProps }) => {
    const theme: SenecEkpTheme = useTheme();
    return (
        <>
            <MonitoringCardHeader topTitle={cardProps.topTitle} infoIcon={cardProps.infoIcon} />
            <Typography color={theme.palette.senecSecondary.neutralGray70} variant={"subtitle1"}>
                {cardProps.errorMessages?.get(MonitoringCardTypeErrors.ERROR_GENERAL)}
            </Typography>
        </>
    );
};
